import { render } from "./day-two-afternoon.vue?vue&type=template&id=77212495"
import script from "./day-two-afternoon.vue?vue&type=script&lang=js"
export * from "./day-two-afternoon.vue?vue&type=script&lang=js"
script.render = render

export default script